import { RoleGate, UserRole } from "@/features/auth";
import { NewDossierDialog } from "@/features/dossier-management";
import { useState } from "react";
import { DossierActions } from "./dossier-actions";
import { DossierList } from "./dossier-list";
import { OngewensteGebeurtenisList } from "./ongewenste-gebeurtenis-list";

export function DossierOverzicht() {
    const [openCreateDossierDialog, setOpenCreateDossierDialog] = useState(false);
    const [preselectedOgNummer, setPreselectedOgNummer] = useState<string | undefined>();

    const onOpenChange = (open: boolean) => {
        setOpenCreateDossierDialog(open);
        if (!open) {
            setPreselectedOgNummer(undefined);
        }
    };
    const onCreateFromSpoorwebDossier = (ogNummer: string) => {
        setPreselectedOgNummer(ogNummer);
        setOpenCreateDossierDialog(true);
    };

    return (
        <>
            <div className="px-m bg-elevated-1 shadow-elevated-2 gap-m relative z-20 flex min-h-24 w-full max-w-screen items-center overflow-y-hidden">
                <RoleGate roles={[UserRole.REGIEVOERDER]}>
                    <DossierActions onCreateNewDossier={() => setOpenCreateDossierDialog(true)} />
                    <OngewensteGebeurtenisList onCreateFromSpoorwebDossier={onCreateFromSpoorwebDossier} />
                    <hr className="border-default h-full border" />
                </RoleGate>
                <RoleGate
                    roles={[
                        UserRole.REGIEVOERDER,
                        UserRole.SUPPORTCONSULTANT,
                        UserRole.KLANTENSERVICE,
                        UserRole.TRANSVISION,
                        UserRole.DEWIT,
                        UserRole.ALLEENLEZEN,
                    ]}
                >
                    <DossierList />
                </RoleGate>
            </div>
            {openCreateDossierDialog && (
                <NewDossierDialog open={openCreateDossierDialog} onOpenChange={onOpenChange} preselectedOgNummer={preselectedOgNummer} />
            )}
        </>
    );
}
